/**
 *
 * @module entry
 * @desc {SDK.Services.Content} entry point.
 *
 */

import ContentClient from './contentClient';
import ContentClientConfiguration from './contentClientConfiguration';
import ContentClientEndpoint from './contentClientEndpoint';
import GraphQlBuilder from './graphQlBuilder';
import GraphQlQuery from './graphQlQuery';
import GraphQlPersistedQuery from './graphQlPersistedQuery';

/**
 *
 * @typedef SDK.Services.Content
 * @type {Object}
 *
 * @property {ContentClient} ContentClient
 * @property {ContentClientConfiguration} ContentClientConfiguration
 * @property {ContentClientEndpoint} ContentClientEndpoint
 * @property {GraphQlBuilder} GraphQlBuilder
 * @property {GraphQlQuery} GraphQlQuery
 * @property {GraphQlPersistedQuery} GraphQlPersistedQuery
 *
 */

/**
 *
 * @type {SDK.Services.Content}
 *
 */
export default {

    ContentClient,
    ContentClientConfiguration,
    ContentClientEndpoint,
    GraphQlBuilder,
    GraphQlQuery,
    GraphQlPersistedQuery

};



// WEBPACK FOOTER //
// ./src/services/content/entry.js